import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {Checkbox, FormControlLabel, Typography} from "@material-ui/core";
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";
import {getParamsFromString} from "../../Utils";
import findByString from "../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../Utils/lib";
import Switch from "@material-ui/core/Switch";

const SwitchComponent = (props) => {
    const [checkboxValue, setCheckBoxValue] = useState(null);
    const [onChangeAction, setOnChangeAction] = useState([])
    const {element, globalValues, screenName, actionsContext, doActions} = props;
    const {properties, styles: sourceStyles, events} = element;
    const styles = sourceStyles ? sourceStyles[0] : {};
    const {userLanguage} = useSelector(state => state.app);

    const multiLanguageLabel = getParamsFromString(multiLanguageValue(properties.label, userLanguage), {...globalValues, ...actionsContext}, screenName);
    const path = getParamsFromString(element.properties.path, {...globalValues, ...actionsContext}, screenName) || false;
    const splited = path.split('.');
    const isArr = !isNaN(splited[splited.length - 1]);
    const isChecked = checkIsChecked();
    const value = getParamsFromString(properties.value, {...globalValues, ...actionsContext}, screenName);

    useEffect(() => {
        if (value && !checkboxValue) {
            setCheckBoxValue(value);
        }
    }, [value])
    useEffect(() => {
        const actions = events ? events[0] ? events[0].actions : undefined : undefined;
        if (actions) {
            if (actions.length) {
                setOnChangeAction(actions)
                return;
            }
            setOnChangeAction(onChangeAction);
        }
    }, []);

    function checkIsChecked() {
        if (properties.value) {
            const withoutIndex = splited.slice(0, -1);
            const arrayPath = withoutIndex.join('.');
            const sourceArray = findByString(globalValues.param[screenName], arrayPath) || [];
            if (isArr) {
                return sourceArray.indexOf(checkboxValue) !== -1;
            }
        }
        const value = findByString({...globalValues.param[screenName], ...actionsContext}, path);
        if (typeof value === "string") {
            return value === 'true';
        }
        if (typeof value === 'boolean') {
            return value;
        }
        return false;
    }

    function onChange(e) {
        e.stopPropagation();
        if (isArr) {
            let withoutIndex = splited.slice(0, -1);
            let arrayPath = withoutIndex.join('.');
            let sourceArray = findByString(globalValues.param[screenName], arrayPath) || [];
            let newArr = e.target.checked ? [...sourceArray, checkboxValue] : sourceArray.filter(i => i !== checkboxValue);
            props.setValue(newArr, arrayPath)
            if (onChangeAction) {
                doActions([onChangeAction], {currentValue: newArr});
            }
            return
        }
        const currentValue = checkboxValue ? e.target.checked ? checkboxValue : false : e.target.checked;
        props.setValue(currentValue, path)
        if(onChangeAction) {
            doActions(onChangeAction, {...actionsContext, currentValue});
        }

    }

    return (
        <FormControlLabel
            labelPlacement={styles.labelPlacement}
            style={{margin: 0}}
            onClick={e => e.stopPropagation()}
            control={
                <Switch
                    disabled={properties.disabled}
                    color={"primary"}
                    checked={isChecked}
                    onChange={onChange}
                    onClick={e => e.stopPropagation()}
                    size={styles.size}
                />}
            label={<Typography style={{fontSize: styles.fontSize}}>{multiLanguageLabel}</Typography>}
        />

    )
}
export default JsonScreenHoc(SwitchComponent);

SwitchComponent.propTypes = {
    element: PropTypes.shape({
        properties: PropTypes.shape({
            label: PropTypes.object,
            value: PropTypes.string,
            path: PropTypes.string
        }),
        styles: PropTypes.array,
        events: PropTypes.array,
    }),
    globalValues: PropTypes.object,
    screenName: PropTypes.string,
    setValue: PropTypes.func
}

